export class AppError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly isRetryable: boolean = false,
  ) {
    super(message);
    this.name = 'AppError';
  }
}

export class NetworkError extends AppError {
  constructor(message: string) {
    super('NETWORK_ERROR', message, true);
    this.name = 'NetworkError';
  }
}

export class ProtocolError extends AppError {
  constructor(message: string) {
    super('PROTOCOL_ERROR', message, false);
    this.name = 'ProtocolError';
  }
}

export class ValidationError extends AppError {
  constructor(
    message: string,
    public readonly field?: string,
  ) {
    super('VALIDATION_ERROR', message, false);
    this.name = 'ValidationError';
  }
}
